import { useQuery } from 'react-query';
import NewsForgeHttpService from '../helpers/news-forge-http.service';
import { ITranslationResponse } from '../models/news-forge.models';
import { useReactQueryMutationWrapper } from '../../../../services/react-query/react-query.helper';
import { showCustomToast } from '../../ArticleAiGeneration/components/subcomponents/schedules-listing-components/subcomponents/custom-toast-norification';
import i18next from 'i18next';
import { GenerateArticleRequestStatuses } from '../../ArticleAiGeneration/helpers/article-ai-generation.helper';

export enum NewsForgeRequestStatusTypes {
	SUCCESSFUL = 'SUCCESSFUL',
	FAILED = 'FAILED',
	PENDING = 'PENDING',
}

export const useNewsForgePolling = (
	jobId: string | null,
	{
		onSuccess,
		onError,
		enabled,
	}: {
		onSuccess: (data: ITranslationResponse) => void;
		onError: (err: any) => void;
		enabled: boolean;
	},
) => {
	return useQuery(
		['newsforge-job-polling', jobId],
		async () => {
			if (!jobId) throw new Error('Missing job ID');
			const { data } = await NewsForgeHttpService.getJobPolling(jobId);
			return data as ITranslationResponse;
		},
		{
			enabled,
			refetchInterval: 10000, // 10 seconds
			refetchIntervalInBackground: true,
			onSuccess: (data) => {
				if (data.status === NewsForgeRequestStatusTypes.SUCCESSFUL || data.status === NewsForgeRequestStatusTypes.FAILED) {
					onSuccess(data);
				}
			},
			onError,
		},
	);
};

export const useExtractAndTranslate = (dispatch: Function, setJobId: Function, setIsExtracting: Function) => {
	return useReactQueryMutationWrapper<{ id: string }, string>(
		async (targetUrl: string) => {
			const response = await NewsForgeHttpService.extractAndTranslate(targetUrl);
			return response.data;
		},
		{
			onSuccess: ({ id }) => {
				setJobId(id);
				setIsExtracting(true);
			},
			onError: (error) => {
				setIsExtracting(false);
				showCustomToast(i18next.t('error'), i18next.t('fill_required_fields'), GenerateArticleRequestStatuses.ERROR);
			},
		},
	);
};

export const useReGenerateTranslation = (setJobId: (id: string) => void, setIsExtracting: (val: boolean) => void) => {
	return useReactQueryMutationWrapper<{ id: string }, { title: string; content: string }>(
		async (body) => {
			const { data } = await NewsForgeHttpService.translateContent(body);
			return data;
		},
		{
			onSuccess: ({ id }) => {
				setJobId(id);
				setIsExtracting(true);
			},
			onError: (error) => {
				setIsExtracting(false);
				showCustomToast(i18next.t('error'), error.message, GenerateArticleRequestStatuses.ERROR);
			},
		},
	);
};
